import axios from "axios";
import { GUEST_VOTE_WEB_HEADERS } from "../utils/guestVote";

export const addVote = async (
  userId,
  goalId,
  token,
  professionalGoal = false
) => {
  try {
    const data = {
      userId,
      goalId,
    };

    if (professionalGoal) {
      data.vote_type = "professional_goal";
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/addVote`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error(error.message);
    }
  }
};


export const addGuestVote = async (
  guest_user_id,
  goalId,
  token,
  vote_type = "goal"
) => {
  try {
    const data = {
      guest_user_id,
      goalId,
       vote_type 
    };


    console.log(data,"data sent to add guest vote api")



    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/addGuestVote`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ...GUEST_VOTE_WEB_HEADERS,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      const payload = error.response.data;
      const err = new Error(payload.message);
      err.requiresRegistration = Boolean(payload.requiresRegistration);
      err.guestVotingDisabled = Boolean(payload.guestVotingDisabled);
      throw err;
    } else {
      throw new Error(error.message);
    }
  }
};
